import { ClassValue } from 'clsx';
import { isNil } from 'lodash';
import React, { useRef, useState } from 'react';
import DotsIcon from '@shared/assets/icons/v2/dots.svg';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBIconButton } from '@shared/components/button';
import { Entity } from '@shared/data/entity/Entity';
import { CardExport } from '@shared/scenes/cards/details/containers/CardExport';
import { ShareSheet } from '@shared/scenes/cards/details/containers/ShareSheet';
import { Colors } from '@shared/styles';
import { useOverflowMenu } from '../../../listView/hooks/useOverflowMenu';

interface Props {
  entity: Entity;
  workflowTemplate: MBAPI.WorkflowTemplate;
  backgroundColor?: string;
  onPressOpenEntity: () => void;
  webHorizontalAlignment?: 'left' | 'right';
  className?: ClassValue;
}

export function CardOverflowButton({
  entity,
  workflowTemplate,
  backgroundColor = Colors.v2.gray05,
  onPressOpenEntity,
  webHorizontalAlignment = 'right',
  className,
}: Props) {
  const [showShareSheet, setShowShareSheet] = useState(false);
  const [showDownloadSheet, setShowDownloadSheet] = useState(false);
  const anchorRef = useRef<MBView>(null);
  const anchorName = `--card-overflow-${entity.id}`;

  const { showOverflowMenu, shouldShowOverflowMenu } = useOverflowMenu({
    entity,
    onShare: () => setShowShareSheet(true),
    onDownload: () => setShowDownloadSheet(true),
    onPressOpenEntity,
    webHorizontalAlignment,
    workflowTemplate,
  });
  if (!shouldShowOverflowMenu) {
    return null;
  }

  const onPress = () => {
    const anchor = anchorRef.current;
    if (!isNil(anchor)) {
      showOverflowMenu(anchor);
    }
  };

  return (
    <View className={className}>
      <MBView ref={anchorRef}>
        <View style={{ anchorName }}>
          <MBIconButton
            source={DotsIcon}
            size="small"
            inverted
            onPress={onPress}
            backgroundColor={backgroundColor}
          />
        </View>
        {showShareSheet && (
          <ShareSheet
            anchorName={anchorName}
            card={{ id: entity.id, workflowTemplateId: workflowTemplate.id }}
            onCloseSheet={() => setShowShareSheet(false)}
          />
        )}
        {showDownloadSheet && (
          <CardExport
            anchorName={anchorName}
            card={{ id: entity.id, workflowTemplateId: workflowTemplate.id }}
            onCloseSheet={() => setShowDownloadSheet(false)}
          />
        )}
      </MBView>
    </View>
  );
}
